module.exports = __webpack_public_path__ + "266a4aa11c2047fff1d697679e075c01.woff2";